import { Role, RBAC_CODE, CacheAPI, APICache } from "../config/app-globals.enum";
import { logoutUser } from "./Logout";
import { adminGetGroupHierarchy, adminGetUser } from "./AdminUserService";
import dotenv from 'dotenv';
dotenv.config();
var _i18next = require("../i18n");
// import { useTranslation } from "react-i18next";

export const getUserData = () => {
    const userData = JSON.parse(window.localStorage.getItem("user"));
    return userData ? userData : null;
};
export const setCompaEnabledForView = (isCompaEnabledForView) => {
    window.localStorage.setItem("isCompaEnabledForView", JSON.stringify(isCompaEnabledForView));
};

export const setDriverIdForTC = (driverId: string) => {
    window.localStorage.setItem("driverIdForTC", JSON.stringify(driverId));
};

export const getDriverIdForTC = () => {
    const driverId = JSON.parse(window.localStorage.getItem("driverIdForTC"));
    return driverId ? driverId : null;
};

export const setTabIdForRE = (tabId: number) => {
    window.localStorage.setItem("TablIdForRE", JSON.stringify(tabId));
};

export const getTabIdForRE = () => {
    const tablId = JSON.parse(window.localStorage.getItem("TablIdForRE"));
    return tablId ? tablId : null;
};

export const setSearchStringForTC = (search: string) => {
    window.localStorage.setItem("searchStringForTC", JSON.stringify(search));
};

export const getSearchStringforTC = () => {
    const search = JSON.parse(window.localStorage.getItem("searchStringForTC"));
    return search ? search : null;
};

export const setDistractionEnabledForView = (isDistractionEnabledForView) => {
    window.localStorage.setItem("isDistractionEnabledForView", JSON.stringify(isDistractionEnabledForView));
};
export const getCompaEnabledForView = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.IsCompaViewEnabled !== undefined && groupPreferences.General.IsCompaViewEnabled !== null) {
        return groupPreferences.General.IsCompaViewEnabled;
    }
    return null;
};

export const getMileageClaimsEnabled = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.MileageClaims && groupPreferences.General.MileageClaims.State === 1) {
        return groupPreferences.General.MileageClaims.State;
    }
    return 0;
};

export const getDistractionEnabledForView = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.IsDistractionViewEnabled !== undefined && groupPreferences.General.IsDistractionViewEnabled !== null) {
        return groupPreferences.General.IsDistractionViewEnabled;
    }
    return null;
};

/**Get value of IsAllowDeleteDriver from group pref */
export const getIsAllowDeleteDriver = (id) => {
    const rawGroups = window.localStorage.getItem("groups");
    if (rawGroups) {
        const groups = JSON.parse(rawGroups);
        if (groups && groups.length > 0) {
            let group = groups.find(el => el.id === id);
            if (group && group.groupPreferences) {
                const groupPreferences = JSON.parse(group.groupPreferences);
                if (groupPreferences && groupPreferences.General && groupPreferences.General.IsAllowDeleteDriver !== undefined && groupPreferences.General.IsAllowDeleteDriver !== null) {
                    return groupPreferences.General.IsAllowDeleteDriver;
                }
            }
        }
    }
    return false;
}

/**Get value of IsAllowAddDriver from group pref */
export const getIsAllowAddDriver = (id) => {
    const rawGroups = window.localStorage.getItem("groups");
    if (rawGroups) {
        const groups = JSON.parse(rawGroups);
        if (groups && groups.length > 0) {
            let group = groups.find(el => el.id === id);
            if (group && group.groupPreferences) {
                const groupPreferences = JSON.parse(group.groupPreferences);
                if (groupPreferences && groupPreferences.General && groupPreferences.General.IsAllowAddDriver !== undefined && groupPreferences.General.IsAllowAddDriver !== null) {
                    return groupPreferences.General.IsAllowAddDriver;
                }
            }
        }
    }
    return false;
}

/**Get Event types which is visible on driver details page */
export const getVisibleEventDetails = () => {
    let eventList: string[] = [];
    try {
        const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
        const groupPreferences = JSON.parse(rawGroupPref);
        if (groupPreferences && groupPreferences.Driving && groupPreferences.Driving.EventTypes !== undefined && groupPreferences.Driving.EventTypes !== null) {
            let eventTypes = Object.keys(groupPreferences.Driving.EventTypes);
            for (let i = 0; i < eventTypes.length; i++) {
                let event = groupPreferences.Driving.EventTypes[eventTypes[i]];
                if (event && event.IsScoringEnabled && event.Preferences && event.Preferences.ShowEventDetails !== undefined && event.Preferences.ShowEventDetails !== null && event.Preferences.ShowEventDetails) {
                    eventList.push(eventTypes[i]);
                }
            }
            if (groupPreferences.General && groupPreferences.General.IsCompaViewEnabled !== undefined && groupPreferences.General.IsCompaViewEnabled !== null && groupPreferences.General.IsCompaViewEnabled !== 0) {
                eventList.push("TRIPS");
            }

            eventList = arrangeTabs(eventList);

            return eventList;
        }
    } catch (error) {
        console.log(error);
    }
    return null;
}

/**Get Event types which is visible on event page */
export const getVisibleEventCount = () => {
    let eventList: string[] = [];
    try {
        const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
        const groupPreferences = JSON.parse(rawGroupPref);
        if (groupPreferences && groupPreferences.Driving && groupPreferences.Driving.EventTypes !== undefined && groupPreferences.Driving.EventTypes !== null) {
            let eventTypes = Object.keys(groupPreferences.Driving.EventTypes);
            for (let i = 0; i < eventTypes.length; i++) {
                let event = groupPreferences.Driving.EventTypes[eventTypes[i]];
                if (event && event.IsScoringEnabled && event.Preferences && event.Preferences.ShowEventCounts !== undefined && event.Preferences.ShowEventCounts !== null && event.Preferences.ShowEventCounts) {
                    eventList.push(eventTypes[i]);
                }
            }
            eventList = arrangeTabs(eventList);

            return eventList;
        }
    } catch (error) {
        console.log(error);
    }
    return null;
}

/**Get visibility of event details by using eventCode */
export const isShowEventDetails = (eventCode) => {
    try {
        if (eventCode !== undefined && eventCode !== null && eventCode.length > 0) {
            const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
            const groupPreferences = JSON.parse(rawGroupPref);
            if (groupPreferences && groupPreferences.Driving && groupPreferences.Driving.EventTypes !== undefined && groupPreferences.Driving.EventTypes !== null) {
                let event = groupPreferences.Driving.EventTypes[eventCode];
                if (event && event.IsScoringEnabled && event.Preferences && event.Preferences.ShowEventDetails !== undefined && event.Preferences.ShowEventDetails !== null && event.Preferences.ShowEventDetails) {
                    return true;
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
    return false;
}

export const isShowEventScore = (eventCode) => {
    try {
        if (eventCode !== undefined && eventCode !== null && eventCode.length > 0) {
            const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
            const groupPreferences = JSON.parse(rawGroupPref);
            if (groupPreferences && groupPreferences.Driving && groupPreferences.Driving.EventTypes !== undefined && groupPreferences.Driving.EventTypes !== null) {
                let event = groupPreferences.Driving.EventTypes[eventCode];
                if (event && event.IsScoringEnabled && event.Preferences && event.Preferences.ShowEventDetails !== undefined && event.Preferences.ShowEventDetails !== null && event.Preferences.ShowEventDetails) {
                    return true;
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
    return false;
}


/**Re-arrange position of received events */
function arrangeTabs(visibleEventDetails) {
    try {
        if (visibleEventDetails) {
            let index = 0;
            let event = visibleEventDetails.find(el => el === "SPEEDING");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("SPEEDING"), 1)[0]);
                index++;
            }
            event = visibleEventDetails.find(el => el === "BRAKING");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("BRAKING"), 1)[0]);
                index++;
            }
            event = visibleEventDetails.find(el => el === "CORNERING");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("CORNERING"), 1)[0]);
                index++;
            }
            event = visibleEventDetails.find(el => el === "ACCELERATION");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("ACCELERATION"), 1)[0]);
                index++;
            }
            event = visibleEventDetails.find(el => el === "DRIVER_DISTRACTION");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("DRIVER_DISTRACTION"), 1)[0]);
                index++;
            }
            event = visibleEventDetails.find(el => el === "TRIPS");
            if (event) {
                visibleEventDetails.splice(index, 0, visibleEventDetails.splice(visibleEventDetails.indexOf("TRIPS"), 1)[0]);
                index++;
            }
            return visibleEventDetails;
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const getRefreshTime = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.DriverLocatorScreenRefreshTime !== undefined && groupPreferences.General.DriverLocatorScreenRefreshTime !== null) {
        return groupPreferences.General.DriverLocatorScreenRefreshTime;
    }
    return 180;
}

export const getMapUrl = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.MapViewCredentials !== undefined && groupPreferences.General.MapViewCredentials !== null && groupPreferences.General.MapViewCredentials.WebMapUrl !== undefined && groupPreferences.General.MapViewCredentials.WebMapUrl !== null) {
        return groupPreferences.General.MapViewCredentials.WebMapUrl;
    }
    return "https://2.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/512/png8?style=flame&apiKey=b-VWrCncjzzP20egaoamKq0pYnghBFd4zywTQ6A9uJ8&ppi=320";
}



export const setLocalStorage = (userData: any) => {
    window.localStorage.setItem("user", JSON.stringify(userData));
};
export const setGroupList = (groupData: any) => {
    window.localStorage.setItem("groups", JSON.stringify(groupData));
};

export const setCurrentGroupPreference = (groupPreferences: any) => {
    if (groupPreferences !== undefined && groupPreferences !== null) {
        window.localStorage.setItem(
            "groupPreferences",
            JSON.stringify(groupPreferences)
        );
    }
};
export const setSession = (sessionData: any) => {
    window.localStorage.setItem("session", JSON.stringify(sessionData));
};

export const setContentSession = (sessionData: any) => {
    window.sessionStorage.setItem("contentSession", JSON.stringify(sessionData));
};

export const setSmartAppDialogState = (smartAppDialogObj: any) => {
    window.sessionStorage.setItem("smartAppDialogState", JSON.stringify(smartAppDialogObj));
};

export const getReportEventPeriod = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.ReportEventPeriod !== undefined && groupPreferences.General.ReportEventPeriod !== null) {
        return groupPreferences.General.ReportEventPeriod;
    }
    return null;
};

export const setEventType = (eventTypeData: any) => {
    window.localStorage.setItem("eventType", JSON.stringify(eventTypeData));
};
export const setEventCategory = (eventTypeData: any) => {
    window.localStorage.setItem("eventCategory", JSON.stringify(eventTypeData));
};
export const setNetworkConnection = (connection: any) => {
    window.localStorage.setItem("networkConnection", JSON.stringify(connection));
};
export const setRequstUrl = (url: any) => {
    window.localStorage.setItem("requestUrl", JSON.stringify(url));
};
export const getNetworkConnection = () => {
    const connection = JSON.parse(
        window.localStorage.getItem("networkConnection")
    );
    return connection ? connection : null;
};

export const getImpersonationDriver = async (impersonationId: any) => {
    let userData = JSON.parse(window.localStorage.getItem("driverImpersonation"));
    let impersonationData = userData.filter(user => user.impersonationId === impersonationId);
    if (impersonationData.length === 0) {
        userData = await setImpersonationUser(impersonationId, userData);
        //Find data with given impersonation driver
        impersonationData = userData.filter(user => user.impersonationId === impersonationId);
    }
    return impersonationData;
};

export const setImpersonationUser = async (impersonationId: any, userList: any) => {
    const data = await adminGetUser(impersonationId);
    if (data.status.code === 0) {
        let userDetails = {
            impersonationId: impersonationId,
            data: data.content
        };
        userList.push(userDetails);
        window.localStorage.setItem("driverImpersonation", JSON.stringify(userList));
        return userList;
    } else {
        return null;
    }
}
//hierarchyGroups
export const getHierarchyGroupList = async (params: any, userId: any) => {
    let groupList = null;
    const impersonationId = params.impersonationid;
    if (impersonationId) {
        let userList = JSON.parse(window.localStorage.getItem("driverImpersonation"));
        if (userList === null) {
            let userList = [];
            const userData = await setImpersonationUser(impersonationId, userList);
            if (userData !== null) {
                const impersonationData = userData.filter(user => user.impersonationId === impersonationId);
                groupList = impersonationData[0].data.groups;
            }
        } else {
            let impersonationData = userList.filter(user => user.impersonationId === impersonationId);
            if (impersonationData.length === 0) {
                const userData = await setImpersonationUser(impersonationId, userList);
                if (userData !== null) {
                    impersonationData = userData.filter(user => user.impersonationId === impersonationId);
                    groupList = impersonationData[0].data.groups;
                }
            } else {
                groupList = impersonationData[0].data.groups;
            }
        }
    } else {
        //groupList = JSON.parse(window.localStorage.getItem("groups"));
        try {
            if (window.localStorage.getItem("hierarchyGroups") !== null) {
                groupList = window.localStorage.getItem("hierarchyGroups");
            } else {
                groupList = await adminGetGroupHierarchy(userId);
                setHierarchyGroupList(groupList ? groupList : null);
                return groupList;
            }
            return (JSON.parse(groupList ? groupList : null));
        } catch (error) {
            console.log(error);
        }
    }
    return groupList ? groupList : null;
};

export const setHierarchyGroupList = (hierarchyData: any) => {
    window.localStorage.setItem("hierarchyGroups", JSON.stringify(hierarchyData));
};

export const getGroupList = async (params: any) => {
    let groupList = null;
    const impersonationId = params.impersonationid;
    if (impersonationId) {
        let userList = JSON.parse(window.localStorage.getItem("driverImpersonation"));
        if (userList === null) {
            let userList = [];
            const userData = await setImpersonationUser(impersonationId, userList);
            if (userData !== null) {
                const impersonationData = userData.filter(user => user.impersonationId === impersonationId);
                groupList = impersonationData[0].data.groups;
            }
        } else {
            let impersonationData = userList.filter(user => user.impersonationId === impersonationId);
            if (impersonationData.length === 0) {
                const userData = await setImpersonationUser(impersonationId, userList);
                if (userData !== null) {
                    impersonationData = userData.filter(user => user.impersonationId === impersonationId);
                    groupList = impersonationData[0].data.groups;
                }
            } else {
                groupList = impersonationData[0].data.groups;
            }
        }
    } else {
        groupList = JSON.parse(window.localStorage.getItem("groups"));
    }
    return groupList ? groupList : null;
};

export const getRequestUrl = () => {
    const requestUrl = JSON.parse(window.localStorage.getItem("requestUrl"));
    return requestUrl ? requestUrl : null;
};
export const unsetRequestUrl = () => {
    window.localStorage.removeItem("requestUrl");
};
export const getCurrentGroupPreference = () => {
    const groupPreferences = JSON.parse(
        window.localStorage.getItem("groupPreferences")
    );
    return groupPreferences ? groupPreferences : null;
};
export const getSession = () => {
    const session = JSON.parse(window.localStorage.getItem("session"));
    return session ? session : null;
};
export const getContentSession = () => {
    const contentSession = JSON.parse(window.sessionStorage.getItem("contentSession"));
    return contentSession ? contentSession : null;
};
export const getSmartAppDialogState = () => {
    const smartAppDialogObj = JSON.parse(window.sessionStorage.getItem("smartAppDialogState"));
    return smartAppDialogObj ? smartAppDialogObj : null;
};
export const getUserRBAC = (entityName: any, props: any) => {
    const session = getSession();
    let rbac = null;
    if (props.match &&
        props.match.params &&
        props.match.params.impersonationid && entityName !== RBAC_CODE.CONTENT_PREVIEW) {
        if (session && session.driver_RBAC && session.driver_RBAC.length) {
            rbac = [...session.driver_RBAC];
        }
    } else if (session && session.user_RBAC && session.user_RBAC.length) {
        rbac = [...session.user_RBAC];
    }
    if (entityName) {
        let entityRBAC = null;
        if (rbac && rbac.length) {
            entityRBAC = rbac.find((entity) => entity.entityCode === entityName);
        }
        return entityRBAC;
    } else {
        return rbac;
    }
};

export const getEventType = () => {
    const eventTypes = JSON.parse(window.localStorage.getItem("eventType"));
    return eventTypes ? eventTypes : null;
};
export const getEventCategory = () => {
    const eventTypes = JSON.parse(window.localStorage.getItem("eventCategory"));
    return eventTypes ? eventTypes : null;
};

export const getEventCategoryFromEventType = (eventTypeId) => {
    const eventTypes = JSON.parse(window.localStorage.getItem("eventType"));
    if (eventTypes) {
        const eventType = eventTypes.find(el => el.id === eventTypeId);
        if (eventType) {
            return eventType.parentEventTypeId;
        }
    }
    return null;
}
export const getDrivingEventType = () => {
    const eventTypes = JSON.parse(window.localStorage.getItem("eventType"));
    return eventTypes ? eventTypes : null;
};
export const updateSession = (updatedSession: any) => {
    const session = JSON.parse(window.localStorage.getItem("session"));
    let response;
    if (session) {
        const newSession = { ...session, ...updatedSession };
        setSession(newSession);
        response = newSession;
    } else {
        response = {};
    }
    return response;
};
export const logOutUser = async () => {
    const session = getSession();
    window.sessionStorage.clear();
    window.localStorage.clear();
    if (session && session.token) {
        await logoutUser(session.token);
    }
    return true;
};

export const isUserDriver = () => {
    const user = getUserData();
    return user.userRoleId.toString() === Role.DRIVER.toString() ? true : false;
};

export const isUserLoggedIn = (props: any) => {
    const userData = getUserData();
    const userSession = getSession();
    const userRBAC = getUserRBAC(null, props);
    return !!(userData && userSession && userRBAC);
};

export const getDeviceId = () => {
    const session = getSession();
    const deviceId = session && session.deviceId ? session.deviceId : null;
    return deviceId;
};

export const getToken = () => {
    const session = getSession();
    const token = session && session.token ? session.token : null;
    return token;
};

export const getContentToken = () => {
    const contentSession = getContentSession();
    const contentToken = contentSession && contentSession.token ? contentSession.token : null;
    return contentToken;
};

export const getCurrentGroupId = () => {
    const user = getUserData();
    const currentCompanyId = user && user.userGroupId ? user.userGroupId : null;
    return currentCompanyId;
};

export const getCurrentGroupName = async (params: any) => {
    const user = getUserData();
    const groups = await getGroupList(params);
    let index = 0;
    if (groups) {
        if (!params.impersonationid) {
            index = groups.findIndex((x) => x.id === user.userGroupId);
        }
        return groups[index].name;
    } else {
        return "";
    }
};

export const getDate = () => {
    const session = getSession();
    const startDate = session && session.startDate ? session.startDate : null;
    const endDate = session && session.endDate ? session.endDate : null;
    return { startDate: startDate, endDate: endDate };
};

export const getStartDate = () => {
    const session = getSession();
    const date: Date = session && session.startDate ? new Date(session.startDate) : null;
    return date;
};

export const getEndDate = () => {
    const session = getSession();
    const date: Date = session && session.endDate ? new Date(session.endDate) : null;
    return date;
};

export const getPageSize = () => {
    const user = getUserData();
    return user && user.SelectionData
        ? user.SelectionData.MaxEventsPerPage
        : null;
};

export const setRows = (rowsPerPage: any) => {
    const user = getUserData();
    user.SelectionData.MaxEventsPerPage = rowsPerPage;
    window.localStorage.setItem("user", JSON.stringify(user));
};

export const getDefaultDates = () => {
    const user = getUserData();
    const startDate =
        user && user.DefaultStartDate ? user.DefaultStartDate : null;
    const endDate = user && user.DefaultEndDate ? user.DefaultEndDate : null;
    return { startDate: startDate, endDate: endDate };
};

// @todo: need appropriate place to put these values
export const getWolStatCat = () => {
    // const { t } = useTranslation();
    return [
        {
            id: 0,
            code: "ALL_DRIVERS",
            name: _i18next.default.t('ALL_DRIVERS'),
            color: "grey",
        },
        {
            id: 1,
            code: "DRIVERS_AT_RISK",
            name: _i18next.default.t("DRIVERS_AT_RISK"),
            color: "red",
        },
        {
            id: 2,
            code: "DRIVERS_NEEDING_ATTENTION",
            name: _i18next.default.t("DRIVERS_NEEDING_ATTENTION"),
            color: "orange",
        },
        {
            id: 3,
            code: "SAFE_DRIVERS",
            name: _i18next.default.t("SAFE_DRIVERS"),
            color: "green",
        },
        {
            id: 4,
            code: "MASTER_DRIVERS",
            name: _i18next.default.t("MASTER_DRIVERS"),
            color: "blue",
        },
        {
            id: 5,
            code: "HALL_OF_FAME",
            name: _i18next.default.t("HALL_OF_FAME"),
            color: "blue",
        },
    ];
};

// @todo: need appropriate place to put these values
export const getCeStatCat = () => {
    // const { t } = useTranslation();
    return [
        {
            id: 0,
            code: "ALL_DRIVERS",
            name: _i18next.default.t("ALL_DRIVERS"),
            color: "grey",
        },
        {
            id: 1,
            code: "DRIVER_WITH_SENT_CONTENT",
            name: _i18next.default.t("DRIVER_WITH_SENT_CONTENT"),
            color: "blue",
        },
        {
            id: 2,
            code: "DRIVER_WITH_ACTIVE_CONTENT",
            name: _i18next.default.t("DRIVER_WITH_ACTIVE_CONTENT"),
            color: "green",
        },
        {
            id: 3,
            code: "DRIVER_WITH_VIDEO_SENT",
            name: _i18next.default.t("DRIVER_WITH_VIDEO_SENT"),
            color: "red",
        },
        {
            id: 4,
            code: "DRIVER_WITH_VIDEO_ACTIVE",
            name: _i18next.default.t("DRIVER_WITH_VIDEO_ACTIVE"),
            color: "green",
        },
    ];
};

// @todo: need appropriate place to put these values
export const getSearchType = () => {
    // const { t } = useTranslation();
    return [
        {
            value: "0",
            label: _i18next.default.t("ALL"),
            placeholder: _i18next.default.t("SEARCH_FOR_USERS_AND_GROUPS"),
        },
        {
            value: "1",
            label: _i18next.default.t("GROUPS"),
            placeholder: _i18next.default.t("SEARCH_FOR_GROUPS"),
        },
        {
            value: "2",
            label: _i18next.default.t("USERS"),
            placeholder: _i18next.default.t("SEARCH_FOR_USERS"),
        },
    ];
};

//Cache API Response
export const setAPIResponse = (url: string, response: any, expiry?: number) => {
    try {
        if (response.content !== null) {
            //Cache API response for 15 min
            const expiryTime = process.env.REACT_APP_API_EXPIRY_TIME_MIN ? process.env.REACT_APP_API_EXPIRY_TIME_MIN : CacheAPI.EXPIRY_TIME_MIN;
            const userData = getUserData();
            const session = getSession();
            url = `${userData.id}/${session.currentGroupId}/${url}`;
            const now = new Date();
            const item = {
                key: url,
                value: response,
                expiry: now.getTime() + (Number(expiryTime) * 60000),
            }
            let setAPI = JSON.parse(window.localStorage.getItem("API"));
            setAPI = setAPI === null ? [] : setAPI;
            /**Check if same api url having response */
            if (setAPI && setAPI.length > 0) {
                let index = setAPI.findIndex((res) => res.key === url);
                if (index !== -1) {
                    /**If same api url response is present then remove that response*/
                    setAPI.splice(index, 1);
                }
            }
            setAPI.push(item);
            window.localStorage.setItem("API", JSON.stringify(setAPI));
        }
    } catch (error) {
        window.localStorage.removeItem("API");
    }

};

//Get the API response from Cache
export const getAPIResponse = (url: string) => {
    const session = getSession();
    const now = new Date();
    //Check session is available or not
    if (session) {
        //Check session expiry date is greater than current date
        const currentDateUTC = new Date(now.toUTCString());
        const tokenExpiry = new Date(session.expiresOn);
        const tokenExpiryUTC = new Date(tokenExpiry.toUTCString());
        if (tokenExpiryUTC > currentDateUTC) {
            const userData = getUserData();
            url = `${userData.id}/${session.currentGroupId}/${url}`;

            let response = JSON.parse(window.localStorage.getItem("API"));
            if (response !== null) {
                let index = response.findIndex((res) => res.key === url);

                if (index !== -1) {
                    //Check response is in Expiry Time if no, remove it
                    if (now.getTime() < response[index].expiry) {
                        return response[index].value;
                    } else {
                        response.splice(index, 1);
                        window.localStorage.setItem("API", JSON.stringify(response));
                    }
                }
            }
        } else {
            // for session expire
            const errorCode = 401;
            return {
                status: { code: errorCode, message: _i18next.default.t(`API_ERROR_CODE_${errorCode}_MESSAGE`) }, content: null,
            };
        }
    }
    return null;
};


export const checkSession = () => {
    const session = getSession();
    //Check session is available or not
    if (session) {
        //Check session expiry date is greater than current date
        const currentDate = new Date();
        const currentDateUTC = new Date(currentDate.toUTCString());
        const tokenExpiry = new Date(session.expiresOn);
        const tokenExpiryUTC = new Date(tokenExpiry.toUTCString());
        if (tokenExpiryUTC < currentDateUTC) {
            const errorCode = 401;
            return {
                status: { code: errorCode, message: _i18next.default.t(`API_ERROR_CODE_${errorCode}_MESSAGE`) }, content: null,
            };
        }
    }
    return null;
}

export const checkAPICallDate = (value: any) => {
    let response = JSON.parse(window.localStorage.getItem("API"));
    if (response !== null) {
        const userData = getUserData();
        const session = getSession();
        let url = `${userData.id}/${session.currentGroupId}${value}`;

        let index = -1;
        if (value === APICache.SPEED_EVENT) {
            index = response.findIndex(element => element.key.includes(url));
        } else {
            index = response.findIndex((res) => res.key === url);
        }
        if (index !== -1) {
            const expiryDate = response[index].expiry;
            const now = new Date();
            //Check expiry time is less than now time
            if (now.getTime() > expiryDate) {
                return new Date();
            } else {
                const expiryTime = process.env.REACT_APP_API_EXPIRY_TIME_MIN ? process.env.REACT_APP_API_EXPIRY_TIME_MIN : CacheAPI.EXPIRY_TIME_MIN;
                const apiCallDate = new Date(expiryDate - (Number(expiryTime) * 60000));
                return apiCallDate;
            }
        }
    }
    return new Date();
}

export const setSpeedZoneIndex = (value) => {
    try {
        window.localStorage.setItem("speedZoneIndex", value);
    } catch (error) {
        console.log(error)
    }

}

export const setSpeedIndex = (value) => {
    try {
        window.localStorage.setItem("speedIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const setEventIndex = (value) => {
    try {
        window.localStorage.setItem("eventIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getEventIndex = () => {
    try {
        if (window.localStorage.getItem("eventIndex") !== undefined && window.localStorage.getItem("eventIndex") !== null && +window.localStorage.getItem("eventIndex") !== -1) {
            return +window.localStorage.getItem("eventIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setBrakingEventIndex = (value) => {
    try {
        window.localStorage.setItem("brakingIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getBrakingEventIndex = () => {
    try {
        if (window.localStorage.getItem("brakingIndex") !== undefined && window.localStorage.getItem("brakingIndex") !== null && +window.localStorage.getItem("brakingIndex") !== -1) {
            return +window.localStorage.getItem("brakingIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setCorneringEventIndex = (value) => {
    try {
        window.localStorage.setItem("corneringIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getCorneringEventIndex = () => {
    try {
        if (window.localStorage.getItem("corneringIndex") !== undefined && window.localStorage.getItem("corneringIndex") !== null && +window.localStorage.getItem("corneringIndex") !== -1) {
            return +window.localStorage.getItem("corneringIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setDistractionEventIndex = (value) => {
    try {
        window.localStorage.setItem("distractionIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getDistractionEventIndex = () => {
    try {
        if (window.localStorage.getItem("distractionIndex") !== undefined && window.localStorage.getItem("distractionIndex") !== null && +window.localStorage.getItem("distractionIndex") !== -1) {
            return +window.localStorage.getItem("distractionIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setAccelerationEventIndex = (value) => {
    try {
        window.localStorage.setItem("accelerationIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getAccelerationEventIndex = () => {
    try {
        if (window.localStorage.getItem("accelerationIndex") !== undefined && window.localStorage.getItem("accelerationIndex") !== null && +window.localStorage.getItem("accelerationIndex") !== -1) {
            return +window.localStorage.getItem("accelerationIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const getSpeedZoneIndex = () => {
    try {
        if (window.localStorage.getItem("speedZoneIndex") !== undefined && window.localStorage.getItem("speedZoneIndex") !== null && +window.localStorage.getItem("speedZoneIndex") !== -1) {
            return +window.localStorage.getItem("speedZoneIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const getSpeedIndex = () => {
    try {
        if (window.localStorage.getItem("speedIndex") !== undefined && window.localStorage.getItem("speedIndex") !== null && +window.localStorage.getItem("speedIndex") !== -1) {
            return +window.localStorage.getItem("speedIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setIsCameFromEventDetailsPage = (value) => {
    try {
        window.localStorage.setItem("isCameFromEventDetailsPage", value);
    } catch (error) {
        console.log(error)
    }
}

export const getIsCameFromEventDetailsPage = () => {
    try {
        if (window.localStorage.getItem("isCameFromEventDetailsPage") !== undefined && window.localStorage.getItem("isCameFromEventDetailsPage") !== null) {
            return +window.localStorage.getItem("isCameFromEventDetailsPage");
        }
    } catch (error) {
        console.log(error)
    }
    return 0;
}

export const setReportedEventDropDownIndex = (value) => {
    try {
        window.localStorage.setItem("dropDownIndex", value);
    } catch (error) {
        console.log(error)
    }
}

export const getReportedEventDropDownIndex = () => {
    try {
        if (window.localStorage.getItem("dropDownIndex") !== undefined && window.localStorage.getItem("dropDownIndex") !== null && +window.localStorage.getItem("dropDownIndex") !== -1) {
            return +window.localStorage.getItem("dropDownIndex");
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const setCountryData = (countryData: any) => {
    window.localStorage.setItem("countryData", JSON.stringify(countryData));
};

export const getCountryData = () => {
    const countryData = JSON.parse(window.localStorage.getItem("countryData"));
    return countryData ? countryData : null;
};

export const getLicenseCheckStatus = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.LicenseCheck !== undefined && groupPreferences.General.LicenseCheck !== null) {
        return groupPreferences.General.LicenseCheck;
    }
    return false;
};

export const getLicenseAddStatus = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.LicenseAdd !== undefined && groupPreferences.General.LicenseAdd !== null) {
        return groupPreferences.General.LicenseAdd;
    }
    return false;
};

export const getLicenseExpireSoonPeriod = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.LicenseExpireSoonPeriod !== undefined && groupPreferences.General.LicenseExpireSoonPeriod !== null) {
        return groupPreferences.General.LicenseExpireSoonPeriod;
    }
    return null;
};

export const getMinResendEconsentDays = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.minResendEconsentDays !== undefined && groupPreferences.General.minResendEconsentDays !== null) {
        return groupPreferences.General.minResendEconsentDays;
    }
    return 0;
}

export const getMinResendValidationDays = () => {
    const rawGroupPref = JSON.parse(window.localStorage.getItem("groupPreferences"));
    const groupPreferences = JSON.parse(rawGroupPref);
    if (groupPreferences && groupPreferences.General && groupPreferences.General.minResendValidationDays !== undefined && groupPreferences.General.minResendValidationDays !== null) {
        return groupPreferences.General.minResendValidationDays;
    }
    return 0;
}